export const SITE_URL = 'https://pobytfoto.pl';
export const APP_STORE_URL = 'https://apps.apple.com/app/id6775184678';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.andreilashkevich.mosphoto';
export const OG_IMAGE_URL = `${SITE_URL}/og-fotopobyt.jpg`;

export const seoCopy = {
  pl: {
    homeTitle: 'Zdjęcie do karty pobytu online 684×883 | FotoPobyt',
    homeDescription: 'Przygotuj zdjęcie do karty pobytu i systemu MOS ze zdjęcia z telefonu. Bezpłatny podgląd, czyste tło i gotowy plik JPG 684 × 883.',
    privacyDescription: 'Dowiedz się, jak FotoPobyt przetwarza zdjęcia, dane aplikacji i zakupy oraz jak możesz skorzystać ze swoich praw do prywatności.',
    termsDescription: 'Poznaj warunki korzystania z FotoPobyt, zasady eksportu zdjęć, płatnych kredytów, wyników AI i odpowiedzialności użytkownika.',
    imageAlt: 'Foto przed i po przygotowaniu do karty pobytu w aplikacji FotoPobyt',
    homeLabel: 'Strona główna',
  },
  en: {
    homeTitle: 'Poland Residence Permit Photo 684×883 | FotoPobyt',
    homeDescription: 'Create a Poland residence permit photo for the MOS system from a phone picture. Free preview, clean background and a ready 684 × 883 JPG.',
    privacyDescription: 'Learn how FotoPobyt processes photos, app data and purchases, and how you can exercise your privacy rights.',
    termsDescription: 'Read the FotoPobyt terms covering photo exports, paid credits, AI-generated results and user responsibilities.',
    imageAlt: 'A phone photo before and after preparation for a Polish residence permit with FotoPobyt',
    homeLabel: 'Home',
  },
  uk: {
    homeTitle: 'Фото для карти побиту 684×883 онлайн | FotoPobyt',
    homeDescription: 'Підготуйте фото для карти побиту й системи MOS зі знімка на телефоні. Безкоштовне прев’ю, чистий фон і готовий JPG 684 × 883.',
    privacyDescription: 'Дізнайтеся, як FotoPobyt обробляє фотографії, дані застосунку та покупки і як скористатися своїми правами на приватність.',
    termsDescription: 'Ознайомтеся з умовами FotoPobyt щодо експорту фото, платних кредитів, результатів ШІ та відповідальності користувача.',
    imageAlt: 'Фото до і після підготовки для карти побиту в застосунку FotoPobyt',
    homeLabel: 'Головна',
  },
  ru: {
    homeTitle: 'Фото на карту побыта 684×883 онлайн | FotoPobyt',
    homeDescription: 'Подготовьте фото на карту побыта и для системы MOS из снимка с телефона. Бесплатное превью, чистый фон и готовый JPG 684 × 883.',
    privacyDescription: 'Узнайте, как FotoPobyt обрабатывает фотографии, данные приложения и покупки и как воспользоваться своими правами на конфиденциальность.',
    termsDescription: 'Ознакомьтесь с условиями FotoPobyt: экспорт фото, платные кредиты, результаты ИИ и ответственность пользователя.',
    imageAlt: 'Фото до и после подготовки для карты побыта в приложении FotoPobyt',
    homeLabel: 'Главная',
  },
  es: {
    homeTitle: 'Foto para permiso de residencia 684×883 | FotoPobyt',
    homeDescription: 'Prepara una foto para el permiso de residencia en Polonia y MOS desde el móvil. Vista previa gratis, fondo limpio y JPG de 684 × 883.',
    privacyDescription: 'Descubre cómo FotoPobyt trata las fotos, los datos de la aplicación y las compras, y cómo ejercer tus derechos de privacidad.',
    termsDescription: 'Consulta las condiciones de FotoPobyt sobre exportaciones, créditos de pago, resultados de IA y responsabilidades del usuario.',
    imageAlt: 'Foto antes y después de prepararla para el permiso de residencia en Polonia con FotoPobyt',
    homeLabel: 'Inicio',
  },
};

export const openGraphLocales = {
  pl: 'pl_PL',
  en: 'en_GB',
  uk: 'uk_UA',
  ru: 'ru_RU',
  es: 'es_ES',
};
